module.exports = __webpack_public_path__ + "img/val-company.5563ffbc.png";